<template>
	<div class="footer-component">
		<p class="copyright">2017. Сноуборды Phantom Equipment.<br>Все права защищены.</p>
		<a class="footer-link-vk" href="https://vk.com/phantom.equipment"><img src="../assets/vk.jpg" width="45" height="45"></img></a>
		<a @click="scrollTop" href="#" class="footer-link">Наверх</a>
	</div>
</template>

<script>
  export default {
    name: 'footerComponent',
    props: ['active'],
    methods: {
		scrollTop () {
			window.scrollTo(0, 0);
		}
    }
  }
</script>

<style scoped>
	.copyright {
		text-align: left;
		color: #fff;
		float: left;
		font-family: opinionprocondensed, Serif;
		font-size: 16px;
		font-weight: 300;
	}

	.footer-component {
		background-color: black;
		padding: 10px 12% 5px 12%;
                justify-content: space-between;
                flex-direction: column;
	}

	.footer-link {
		float: right;
		color: #fff;
		font-size: 18px;
		margin-top: 5px;
		font-family: opinionprocondensed, serif;
		text-transform: uppercase;
	}

	.footer-link-vk {
                margin-left: 10px;
		align-items: center;
		color: #fff;
		font-size: 18px;
		font-family: opinionprocondensed, serif;
		text-transform: uppercase;
	}

	@media all and (max-width:1600px) {
		.footer-component {
			padding: 10px 10% 5px 10%
		}
	}

	@media all and (max-width:1500px) {
		.footer-component {
			padding: 10px 8% 5px 8%
		}
	}

	@media all and (max-width:1400px) {
		.footer-component {
			padding: 10px 6% 5px 6%
		}
	}

	@media all and (max-width:1350px) {
		.footer-component {
			display: flex;
			flex-direction: column-reverse;
			justify-content: center;
			align-items: center;
			padding: 10px 4% 5px 4%
		}

		.copyright {
			margin-top: 5px;
			float: none;
		}
	}

	@media all and (max-width:1250px) {
		.footer-component {
			display: flex;
			justify-content: center;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/footerComponent.vue?0505324e